import { Badge, type badgeVariants } from '@src/design-system/badge';
import type { TNavLink } from './types';
import type { VariantProps } from 'class-variance-authority';

type BadgeVariant = VariantProps<typeof badgeVariants>['variant'];

const BADGE_PROPS: Record<
  string,
  { label: string; variant: BadgeVariant; className?: string }
> = {
  beta: {
    label: 'Beta',
    variant: 'primaryBlue',
    className:
      'bg-gradient-to-l from-secondary-1000 to-secondary-1000/80 text-white',
  },
  new: {
    label: 'New',
    variant: 'success',
    className:
      'bg-gradient-to-l from-green-500 to-green-500/80 text-white text-white',
  },
};

export const NavLinkBadge = ({ item }: { item: TNavLink }) => {
  const label = item.badgeLabel;
  if (!label) return null;

  const badgeProps = BADGE_PROPS[label.toLowerCase()] ?? {
    label,
    variant: 'default',
  };

  return (
    <Badge
      variant={badgeProps.variant}
      className={badgeProps.className}
    >
      {badgeProps.label}
    </Badge>
  );
};
